export class GetDeploymentTypesResponse {
    deploymentTypes?: string[];
}